import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/services/")({
  head: () => buildRouteHead("/es/services/", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios", replace: true });
  },
});
